export default{
    photos: [
    {
        id: 1,
        description: 'No student looked like this back then!!',
        url: 'https://source.unsplash.com/ASuIYgjnBFw',
        year: 2013,
        hashtags: [
            "isc",
            "puberty",
            "sexy",
            "white"
        ],
        mentions: [
            'pristinha'
        ]
    },
    {
        id: 2,
        description: 'I wish I went to her school!!',
        url: 'https://source.unsplash.com/wZEf1Y6Kxs0',
        year: 2014,
        hashtags: [
            "isc",
            "puberty",
            "freckles",
            "girl"
        ],
        mentions: [
            'oceanswide'
        ]
    },
    {
        id: 3,
        description: 'No we did not have swimming (or sports)!!',
        url: 'https://source.unsplash.com/FBipORWOxSo',
        year: 2015,
        hashtags: [
            "icse",
            "swim",
            "water",
            "boy"
        ],
        mentions: [
            'usman_haider'
        ]
    },
    {
        id: 4,
        description: 'We did not have such a diverse gang!!',
        url: 'https://source.unsplash.com/jNVgCpQ0LhQ',
        year: 2012,
        hashtags: [
            "isc",
            "girl",
            "gang",
            "diversity"
        ],
        mentions: [
            'gemmachuatran', 'nathannichols'
        ]
    },
    {
        id: 5,
        description: 'The coolest band that never existed!!',
        url: 'https://source.unsplash.com/nOFXvnRMMK4',
        year: 2013,
        hashtags: [
            "icse",
            "band",
            "music",
            "boy"
        ],
        mentions: [
            'nathannichols', 'usman_haider'
        ]
    },
]
} 




// WEBPACK FOOTER //
// ./src/data/photos.js